<div class="modal-header" workflowConditionDrag>
  <div><h4 class="modal-title" id="workflow-condition-title">{{_('Bedingungen bearbeiten')}}</h4>
    <p class="qa-condition-intro" [attr.title]="stageName">{{stageName}}</p></div>
  <button type="button" class="close" [attr.aria-label]="_('Schließen')" (click)="activeModal.dismiss()">&times;</button>
</div>
<div class="modal-body qa-condition-body" *ngIf="!choosing; else picker">
  <div class="qa-condition-heading"><span class="qa-condition-badge">{{_('SCHRITT AUSFÜHREN')}}</span>
    <label *ngIf="group"><input type="checkbox" [(ngModel)]="advanced"> {{_('Weitere Optionen')}}</label></div>
  <ng-container *ngIf="group; else unsupported">
    <ng-container *ngTemplateOutlet="node; context: {$implicit: group}"></ng-container>
    <div class="qa-condition-preview" aria-live="polite">
      <span *ngIf="group.children.length" class="qa-dependency-caption">{{_('Diesen Schritt ausführen, wenn')}}</span>
      <app-workflow-condition-summary [root]="group" [variables]="variables"></app-workflow-condition-summary>
    </div>
  </ng-container>
  <ng-template #unsupported>
    <div class="qa-dependency-warning" role="status">{{_('Dieser Ausdruck kann nicht im visuellen Editor bearbeitet werden. Er bleibt unverändert.')}}</div>
  </ng-template>
  <details *ngIf="expression"><summary>{{_('Technischen Ausdruck anzeigen')}}</summary><code class="qa-condition-source">{{expression}}</code></details>
  <p *ngIf="validation" class="qa-condition-validation" role="status">{{_(validation)}}</p>
  <p class="qa-condition-help">{{_('Änderungen werden erst mit Übernehmen wirksam.')}}</p>
</div>
<div class="modal-footer" *ngIf="!choosing">
  <button *ngIf="existing || (group && group.children.length)" type="button" class="btn btn-outline-danger mr-auto"
          (click)="clear()">{{_('Bedingungen entfernen')}}</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">{{_('Abbrechen')}}</button>
  <button type="button" class="btn btn-primary" [disabled]="!!validation" (click)="save()">{{_('Übernehmen')}}</button>
</div>

<ng-template #node let-group let-parent="parent" let-index="index">
  <div class="qa-condition-group">
    <div class="qa-condition-group-heading">
      <select class="form-control form-control-sm" [(ngModel)]="group.operator" [attr.aria-label]="_('Bedingungen verknüpfen')">
        <option value="&&">{{_('Alle Bedingungen müssen zutreffen')}}</option>
        <option value="||">{{_('Mindestens eine Bedingung muss zutreffen')}}</option>
      </select>
      <button *ngIf="parent" type="button" class="qa-condition-remove" (click)="remove(parent, index)"
              [attr.aria-label]="_('Gruppe entfernen')">&times;</button>
    </div>
    <div *ngFor="let child of group.children; let i = index" class="qa-condition-child">
      <div *ngIf="i" class="qa-dependency-join">{{_(group.operator === '||' ? 'ODER' : 'UND')}}</div>
      <ng-container *ngIf="child.kind === 'group'; else rule">
        <ng-container *ngTemplateOutlet="node; context: {$implicit: child, parent: group, index: i}"></ng-container>
      </ng-container>
      <ng-template #rule>
        <div class="qa-condition-rule" [class.qa-dependency-invalid]="child.variable && issue(child)">
          <div class="qa-condition-rule-main">
            <button type="button" class="qa-condition-variable" (click)="choose(child)" [attr.title]="name(child) + '\n' + child.variable">
              <i class="fa" [ngClass]="source(child)?.group === 'questionnaire' ? 'fa-check-square-o' : 'fa-code'" aria-hidden="true"></i>
              <span class="qa-dependency-source-label">{{name(child)}}</span><i class="fa fa-angle-down" aria-hidden="true"></i>
            </button>
            <button type="button" class="qa-condition-remove" (click)="remove(group, i)"
                    [attr.aria-label]="_('Bedingung entfernen')">&times;</button>
          </div>
          <div *ngIf="child.variable" class="qa-dependency-comparison">
              <select class="form-control" [(ngModel)]="child.operator" [attr.aria-label]="_('Vergleich')">
                <option *ngFor="let operator of comparisons(child)" [value]="operator">{{_(operators[operator] || operator)}}</option>
              </select>
              <ng-container [ngSwitch]="type(child)">
                <select *ngSwitchCase="'boolean'" class="form-control" [(ngModel)]="child.value" [attr.aria-label]="_('Vergleichswert')">
                  <option [ngValue]="true">{{_('Ja')}}</option><option [ngValue]="false">{{_('Nein')}}</option>
                </select>
                <input *ngSwitchCase="'number'" type="number" step="any" class="form-control" [(ngModel)]="child.value"
                       [attr.aria-label]="_('Vergleichswert')" [placeholder]="_('Vergleichswert')">
                <input *ngSwitchCase="'date'" class="form-control" [type]="dateInput(child)"
                       [ngModel]="dateValue(child)" (ngModelChange)="setDate(child, $event)" [attr.aria-label]="_('Vergleichswert')">
                <ng-container *ngSwitchDefault>
                  <select *ngIf="source(child)?.choices?.length; else textValue" class="form-control"
                          [(ngModel)]="child.value" [attr.aria-label]="_('Vergleichswert')">
                    <option [ngValue]="child.value" hidden>{{child.value || _('Wert wählen')}}</option>
                    <option *ngFor="let option of source(child).choices" [ngValue]="option.value">{{option.label}}</option>
                  </select>
                  <ng-template #textValue><input type="text" class="form-control" [(ngModel)]="child.value"
                    [attr.aria-label]="_('Vergleichswert')" [placeholder]="_('Vergleichswert')"></ng-template>
                </ng-container>
              </ng-container>
          </div>
          <p *ngIf="child.variable && issue(child)" class="qa-dependency-warning" role="status">{{_(issue(child))}}</p>
        </div>
      </ng-template>
    </div>
    <p *ngIf="!group.children.length" class="qa-dependency-empty">{{_(parent ? 'Bitte ergänzen oder entfernen Sie die leere Gruppe.' : 'Dieser Schritt wird immer ausgeführt.')}}</p>
    <div class="qa-condition-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="add(group)">+ {{_('Bedingung hinzufügen')}}</button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="add(group, true)">+ {{_('Untergruppe hinzufügen')}}</button>
    </div>
  </div>
</ng-template>

<ng-template #picker>
  <div class="modal-body qa-condition-body">
    <h5>{{_('Variable wählen')}}</h5>
    <p class="qa-condition-help">{{_('Wählen Sie eine der im Workflow zugeordneten Variablen.')}}</p>
    <input ngbAutofocus type="search" class="form-control mt-3" [(ngModel)]="query"
           [placeholder]="_('Variablen durchsuchen')" [attr.aria-label]="_('Variablen durchsuchen')">
    <div class="qa-variable-filters" [attr.aria-label]="_('Variablen filtern')">
      <button *ngFor="let filter of ['', 'survey', 'questionnaire']" type="button" class="btn btn-sm btn-outline-secondary"
              [class.active]="category === filter" [attr.aria-pressed]="category === filter" (click)="category = filter">
        {{_(filter === 'survey' ? 'Patient und Befragung' : filter === 'questionnaire' ? 'Fragebogen' : 'Alle')}}</button>
    </div>
    <div class="qa-variable-results">
      <button *ngFor="let variable of matches" type="button" class="qa-variable-result" (click)="select(variable)"
              [attr.title]="variable.label + '\n' + variable.name + '\n' + variable.detail">
        <strong>{{variable.label}}</strong><span>{{variable.name}} · {{variable.detail}}</span>
      </button>
      <p *ngIf="!matches.length" class="qa-picker-empty">{{_(variables.length ? 'Keine passenden Variablen gefunden.' :
        'Noch keine Variablen zugeordnet. Fügen Sie eine neue Zuordnung hinzu.')}}</p>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="createVariable" type="button" class="btn btn-primary mr-auto" [disabled]="creating" (click)="addVariable()">{{_('Neue Variable zuordnen')}}</button>
    <button type="button" class="btn btn-secondary" (click)="choosing = null">{{_('Zurück zu den Bedingungen')}}</button>
  </div>
</ng-template>
